import { db, FirebaseTimestamp } from 'firebase/index'
import { Action, Dispatch } from 'redux'
import { StoreGeoSearch } from 'types/storeGeoSearch'
import { fetchStoreGeoSearch } from 'repos/storeGeoSearch'
import { State } from 'index'
import { StoreStatus } from 'types/store'

const saveStoreGeoSearch = (params: {
  imageUrls: string[]
  status?: StoreStatus
  storeAddress: string
  storeId: string
  storeName: string
  storeGeoSearch: StoreGeoSearch | undefined
}) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const { imageUrls, status, storeAddress, storeId, storeName, storeGeoSearch } = params
    if (!storeGeoSearch) return
    const storeRef = db.collection('stores').doc(storeId)
    const beforeStoresGeoSearch = await fetchStoreGeoSearch(storeRef)
    const now = FirebaseTimestamp.now()
    storeGeoSearch.d.created_at = beforeStoresGeoSearch ? beforeStoresGeoSearch.d.created_at : now
    storeGeoSearch.d.updated_at = now
    storeGeoSearch.d.store_address = storeAddress
    storeGeoSearch.d.image_url = imageUrls[0] || ''
    storeGeoSearch.d.store_name = storeName
    storeGeoSearch.d.store_ref = storeRef
    storeGeoSearch.d.status = status || getState().confirm.store.status
    await db.collection('stores_geo_search').doc(storeId).set(storeGeoSearch)
  }
}

export default saveStoreGeoSearch
